var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing-page"}},[_c('page-header'),_c('video-intro'),_c('promo'),_c('congress-table-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }